<template>
  <div class="home">
    <template
      v-if="
        wpPageId === 1808 
      "
    >
    <Splash :acf="acf" :id="wpPageId" />
    <div class="backgroundImage">
    </div>

            <div class="container">
                <!-- <h2 class="textTitle"> {{acf.title.rendered}}  </h2> -->
                <p class="enterpriseParagraph" v-html="acf.content.rendered"></p>
            </div>
    </template>
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import Footer from "@/components/footer.vue";
import Splash from "@/components/splash.vue";
export default {
  name: "Enterprise",
  components: { Footer, Splash},
  data: function() {
    return {
      acf: [],
    };
  },
  computed: {
    wpPageId: function(page) {
      if (this.$route.name === "enterprise-tour-management-vs-club-software") page = 1808;
      return page;
    },
  },
  mounted() {
    axios //add API Call
      .get(
        process.env.VUE_APP_API_URL + "/wp-json/wp/v2/pages/" + this.wpPageId
      ) // Page number changed on each page based on JSON page id you are calling
      .then((response) => (this.acf = response.data)); //API data wanted pulled out
  },
};
</script>

<style scoped>
.backgroundImage {
    /* background-image: url(https://wp-ocssport.ocs-sport.com/wp-content/uploads/2021/02/golf-course-copy_2.jpg);
    height: 70vh;
    background-position: center;
    background-size: cover; */
    margin-bottom: 50px;
}
h2.textTitle {
    font-size: 50px;
    padding-bottom: 50px;
}
::v-deep h2.wp-block-heading {
    color: #00aeef;
    font-size: 20px;
}
::v-deep h1.wp-block-heading {
    font-size: 30px;
}
p.enterpriseParagraph {
    font-size: 1rem;
    font-weight: 400;
}
.textSub{
    color: #00aeef;
    font-weight: 600;
    text-align: center;
    margin-top: 50px!important;
    width: 1200px;
    margin: auto;
}
::v-deep .containerSep {
  max-width: 1400px;
  padding: 0;
}
.secPad {
  padding: 100px;
  padding-top: 110px;
  padding-bottom: 110px;
}
.grey {
  background-color: #f4f4f6;
}
.cta {
  background-repeat: no-repeat;
  background-size: cover;
}
.ctaTop {
  padding: 25px;
}
.ctaPad {
  padding: 68px;
}
.mobSize {
  display: none;
}
@media only screen and (max-width: 1260px) {
  .lgSize {
    display: none;
  }
  .mobSize {
    display: block;
  }
  .ctaPadMob {
    padding: 150px 254px 100px 60px;
  }
}
@media only screen and (max-width: 1024px) {
  .ctaPadMob {
    padding: 115px 254px 100px 60px;
  }
}
@media only screen and (max-width: 768px) {
  .secPad {
    padding: 50px;
  }
  .ctaPadMob {
    padding: 125px 100px 100px 45px;
  }
}

@media only screen and (max-width: 480px) {
  .secPad {
    padding: 25px;
  }
  .ctaPadMob {
    padding: 125px 35px 100px 45px;
  }
}
</style>
